import { render, staticRenderFns } from "./SimpleDropdown.vue?vue&type=template&id=59ec4410"
import script from "./SimpleDropdown.vue?vue&type=script&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports